var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './Avatar.styles.scss';
var Avatar = function (_a) {
    var ariaLabel = _a.ariaLabel, userName = _a.userName, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, _c = _a.size, size = _c === void 0 ? 'xxs' : _c;
    var formatName = function (name) {
        var initials = name
            .split(' ')
            .filter(function (splittedName) { return splittedName; })
            .map(function (filteredName) { return filteredName.slice(0, 1).toUpperCase(); });
        if (initials.length) {
            return initials.length >= 2
                ? "".concat(initials[0]).concat(initials[initials.length - 1])
                : initials[0];
        }
        return '';
    };
    return (_jsx("div", __assign({ "aria-label": ariaLabel, className: "hefesto-avatar hefesto-avatar--".concat(variant, " hefesto-avatar--").concat(size), title: userName }, { children: _jsx("span", __assign({ className: "hefesto-avatar hefesto-avatar--".concat(variant, " hefesto-avatar--").concat(size) }, { children: formatName(userName) })) })));
};
export default Avatar;
